import { useLocation } from 'react-router-dom';
import { CUSTOM_CATEGORIES } from 'utils/constants/casino/custom-categories';
import { mountPoint } from 'utils/generic/route-manipulation';
import { useSbRouteMatch } from 'newhooks/generic/useSbRouteMatch';
import { CasinoGamesConfigs } from '../providers/CasinoGamesConfigsContext';

export const useSelectedCategory = ({
  configs
}: {
  configs: Partial<CasinoGamesConfigs>;
}) => {
  const location = useLocation();
  const routeMatch = useSbRouteMatch(
    `${mountPoint(location.pathname, false, true)}/:category`
  );

  const selectedCategory =
    !configs.bindWithCategories && !configs.groupAllByCategories
      ? configs.categoryIds || CUSTOM_CATEGORIES.all.id
      : routeMatch?.params?.category || CUSTOM_CATEGORIES.all.id;

  return { selectedCategory };
};
